/*
    设备完好率 -top50电站
 */
import React, { Component } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import { Tooltip } from "antd";
import moment from "moment";
import { getStubGroupRate } from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import "@/assets/stylus/data_analysis.styl";

class StationIntactTop10 extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      tableDate: [],
      tableConfig: this.initTable(),
      sortFunc: {
        sortKey: "2",
        sortFun: "1",
      },
      cityId: this.props.param.cityId,
      operationProperty: this.props.param.operationProperty,
      operationMode: this.props.param.operationMode,
      type: this.props.param.type,
      time: this.props.param.date,
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  /**
   *  父组件条件修改子组件进行更新
   */
  componentWillMount() {
    this.setState({
      currentState: this.queryStubName,
      currentDate: this.queryCurrent,
    });

    this.queryEndCodeChargInfo();
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分`; // + second + "秒";
    } else if (hour > 0) {
      return `${hour}时${minute}分`; // + second + "秒";
    } else if (minute > 0) {
      return `${minute}分`; // + second + "秒";
    } else {
      return `${second}秒`;
    }
  }

  // 获取选取的日期
  changeDay = (value) => {
    console.log(value);
  };

  /**
   * 表格初始化
   */
  initTable() {
    const tableConfig = {
      tableKey: "stubGroupListTableTop10",
      // noPagination: true,
      tableColumns: [
        {
          name: "排名",
          key: "serial",
          colType: "textCol",
          align: "center",
        },
        {
          name: "电站",
          key: "stubGroupName",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            const props = {
              stubGroupName: value,
              stubGroupId: row.stubGroupId,
            };
            const msg = value.length > 10 ? <Tooltip title={value}>{`${value.substring(0, 10)}……`}</Tooltip> : <div>{value}</div>;
            return (
              <a
                onClick={() => {
                  this.openDetail(props);
                }}>
                {msg}
              </a>
            );
          },
        },
        {
          name: "设备总数",
          key: "stubCnt",
          colType: "textCol",
          align: "center",
        },
        {
          name: "地区",
          key: "cityName",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            if (row.areaName === "--" || row.cityName === "--" || row.provinceName === "--") {
              return "--";
            } else {
              return `${row.provinceName}-${row.cityName}-${row.areaName}`;
            }
          },
        },
        {
          name: "平均可用时长",
          message: (
            <div className='mcjs'>
              <p>
                <b>可用时长：</b>运营时长 + 维护时长；
              </p>
              <p>
                <b>平均可用时长：</b>所有统计设备的平均可用时长。
              </p>
            </div>
          ),
          key: "totalAvailableDuration",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            if (row.availableCnt !== "--" && row.availableCnt !== 0) {
              return this.handleSecord(parseInt(value / row.availableCnt));
            } else {
              return "--";
            }
          },
        },
        {
          name: "平均运营时长",
          message: (
            <div className='mcjs'>
              <p>
                <b>运营时长：</b>空闲时长（包含插枪空闲时长） + 充电中时长 + 车位占用时长 + 故障时长 + 离线时长 +
                升级中时长 + 预约等待充电中时长 + 储能中时长 + 在线预约中时长 + 充满时长；
              </p>
              <p>
                <b>平均运营时长：</b>所有统计设备的平均运营时长。
              </p>
            </div>
          ),
          key: "totalOperationDuration",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            if (row.stubCnt !== "--" && row.stubCnt !== 0) {
              return this.handleSecord(parseInt(value / row.stubCnt));
            } else {
              return "--";
            }
          },
        },
        {
          name: "可用率",
          message: (
            <div className='mcjs'>
              <p>
                <b>可用率</b>=（可用时长 - 维护时长）/可用时长
              </p>
            </div>
          ),
          key: "availableRate",
          colType: "textCol",
          // sorter:true,
          align: "center",
          render: (value) => {
            return `${value}%`;
          },
        },
        {
          name: "平均故障时长",
          message: (
            <div className='mcjs'>
              <p>
                <b>故障时长：</b>
                设备变更为故障状态开始计时到设备变更为另一个状态为止的时间段。
              </p>
              <p>
                <b>平均故障时长：</b>故障时长之和/设备总数。
              </p>
            </div>
          ),
          key: "totalErrorDuration",
          colType: "textCol",
          align: "center",
          render: (value, row) => {
            if (row.stubCnt !== "--" && row.stubCnt !== 0) {
              return this.handleSecord(parseInt(value / row.stubCnt));
            } else {
              return "--";
            }
          },
        },
        {
          name: "故障率",
          message: (
            <div className='mcjs'>
              <p>
                <b>故障率</b>=故障时长/运营时长
              </p>
            </div>
          ),
          key: "errorRate",
          colType: "textCol",
          // sorter:true,
          align: "center",
          render: (value) => {
            return `${value}%`;
          },
        },
        {
          name: "平均离线时长",
          key: "totalOfflineDuration",
          colType: "textCol",
          align: "left",
          message: (
            <div className='mcjs'>
              <p>
                <b>离线时长：</b>
                设备变更为离线状态开始计时到设备变更为另一个状态为止的时间段。
              </p>
              <p>
                <b>平均离线时长:</b>离线时长之和/设备总数。
              </p>
            </div>
          ),
          render: (value, row) => {
            if (row.stubCnt !== "--" && row.stubCnt !== 0) {
              return this.handleSecord(parseInt(value / row.stubCnt));
            } else {
              return "--";
            }
          },
        },
        {
          name: "离线率",
          key: "offlineRate",
          colType: "textCol",
          // sorter:true,
          align: "center",
          message: (
            <div className='mcjs'>
              <p>
                <b>离线率</b>=离线时长/运营时长
              </p>
            </div>
          ),
          render: (value) => {
            return `${value}%`;
          },
        },
        {
          name: "平均完好时长",
          key: "cityName",
          colType: "textCol",
          align: "left",
          message: (
            <div className='mcjs'>
              <p>
                <b>完好时长</b>=运营时长 - 故障时长 -离线时长。
              </p>
              <p>
                <b>平均完好时长:</b>所有统计设备的平均完好时长。
              </p>
            </div>
          ),
          render: (value, row) => {
            if (row.stubCnt !== "--" && row.stubCnt !== 0) {
              const allAvg = parseInt(row.totalOperationDuration / row.stubCnt);
              const errAvg = parseInt(row.totalErrorDuration / row.stubCnt);
              const offLineAvg = parseInt(row.totalOfflineDuration / row.stubCnt);
              const intactAvg = this.handleSecord(allAvg - errAvg - offLineAvg);
              return intactAvg;
            } else {
              return "--";
            }
          },
        },
        {
          name: "完好率",
          key: "intactRate",
          colType: "textCol",
          // sorter:true,
          align: "center",
          message: (
            <div className='mcjs'>
              <p>
                <b>完好率</b>=(运营时长-离线时长-故障时长)/运营时长
              </p>
            </div>
          ),
          render: (value) => {
            return `${value}%`;
          },
        },
      ],
      tableChange: (pagination, filters, sorter) => {
        console.log(sorter);
      },
      tableParam: {
        pagecount: 10,
      },
      dataApi: this.state ? this.state.tableDate : [],
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };

    return tableConfig;
  }

  //
  openTab = (param, e) => {
    this.props.onAdd(e, param);
    // this.props.handle && this.props.handle()
  };

  openDetail = (props) => {
    this.openTab(
      {
        stubName: props.stubGroupName,
        stubGroupId: props.stubGroupId,
        choosedData: moment(new Date()).subtract(0, "d").format("YYYYMMDD"),
      },
      {
        key: "stubStationIntact",
        titleText: "电站完好率趋势",
      },
    );
  };

  // 调用接口获取数据
  queryEndCodeChargInfo() {
    fetchHandler(getStubGroupRate, {
      cityId: this.state.cityId,
      operationProperty: this.state.operationProperty,
      operationMode: this.state.operationMode,
      type: this.state.type,
      time: this.state.time,
      sortType: this.state.sortFunc.sortKey,
      sortWay: this.state.sortFunc.sortFun,
    }).then((res) => {
      // res.data = [{"serial":1,"cityId":"320412","date":"202110","operationMode":"1","operationProperty":"3","type":1,"createTime":null,"totalErrorStub":1,"totalOfflineStub":0,"totalOfflineDuration":0,"totalErrorDuration":1641600,"totalOperationDuration":1641600,"stubCnt":1,"totalAvailableDuration":1641600,"totalMaintDuration":0,"availableCnt":1,"errorRate":100.00,"offlineRate":0.00,"intactRate":0.00,"availableRate":100.00,"cityName":"常州市","provinceName":"江苏省","areaName":"武进区","stubGroupId":"329b0def-4233-4b94-9375-d3e80520dc76","stubGroupName":"恒力液压充电站（不对外）","stubId":null,"frameWork":null,"modelNo":null,"updateType":null},{"serial":2,"cityId":"320412","date":"202110","operationMode":"1","operationProperty":"3","type":1,"createTime":null,"totalErrorStub":1,"totalOfflineStub":0,"totalOfflineDuration":0,"totalErrorDuration":1641600,"totalOperationDuration":1641600,"stubCnt":1,"totalAvailableDuration":1641600,"totalMaintDuration":0,"availableCnt":1,"errorRate":100.00,"offlineRate":0.00,"intactRate":0.00,"availableRate":100.00,"cityName":"常州市","provinceName":"江苏省","areaName":"武进区","stubGroupId":"3a3f93aa-759e-498f-9e36-6ccf2eb9c73c","stubGroupName":"中梁柏悦（测试站不对外）","stubId":null,"frameWork":null,"modelNo":null,"updateType":null},{"serial":3,"cityId":"320412","date":"202110","operationMode":"1","operationProperty":"3","type":1,"createTime":null,"totalErrorStub":4,"totalOfflineStub":1,"totalOfflineDuration":1641600,"totalErrorDuration":6566400,"totalOperationDuration":8208000,"stubCnt":5,"totalAvailableDuration":8208000,"totalMaintDuration":0,"availableCnt":5,"errorRate":80.00,"offlineRate":20.00,"intactRate":0.00,"availableRate":100.00,"cityName":"常州市","provinceName":"江苏省","areaName":"武进区","stubGroupId":"4b909e6a-e08e-46d2-a6ba-25f8c9879f5b","stubGroupName":"新石器（武进高新区beta测试不对外）","stubId":null,"frameWork":null,"modelNo":null,"updateType":null},{"serial":4,"cityId":"310101","date":"202110","operationMode":"1","operationProperty":"3","type":1,"createTime":null,"totalErrorStub":1,"totalOfflineStub":0,"totalOfflineDuration":0,"totalErrorDuration":1641600,"totalOperationDuration":1641600,"stubCnt":1,"totalAvailableDuration":1641600,"totalMaintDuration":0,"availableCnt":1,"errorRate":100.00,"offlineRate":0.00,"intactRate":0.00,"availableRate":100.00,"cityName":"市辖区","provinceName":"上海市","areaName":"黄浦区","stubGroupId":"67d6d35f-99de-42c5-8b15-be72dcbc28a8","stubGroupName":"上海测试充电站","stubId":null,"frameWork":null,"modelNo":null,"updateType":null},{"serial":5,"cityId":"320412","date":"202110","operationMode":"1","operationProperty":"3","type":1,"createTime":null,"totalErrorStub":2,"totalOfflineStub":0,"totalOfflineDuration":0,"totalErrorDuration":3283200,"totalOperationDuration":3283200,"stubCnt":2,"totalAvailableDuration":3283200,"totalMaintDuration":0,"availableCnt":2,"errorRate":100.00,"offlineRate":0.00,"intactRate":0.00,"availableRate":100.00,"cityName":"常州市","provinceName":"江苏省","areaName":"武进区","stubGroupId":"5d507d8d-6fcd-4bae-a5f3-55a4508909ea","stubGroupName":"西门子汽车充电站（beta用不对外开放）","stubId":null,"frameWork":null,"modelNo":null,"updateType":null},{"serial":6,"cityId":"320412","date":"202110","operationMode":"1","operationProperty":"3","type":0,"createTime":null,"totalErrorStub":1,"totalOfflineStub":0,"totalOfflineDuration":0,"totalErrorDuration":1641600,"totalOperationDuration":1641600,"stubCnt":1,"totalAvailableDuration":1641600,"totalMaintDuration":0,"availableCnt":1,"errorRate":100.00,"offlineRate":0.00,"intactRate":0.00,"availableRate":100.00,"cityName":"常州市","provinceName":"江苏省","areaName":"武进区","stubGroupId":"19779775-3bf5-439d-924a-c5de6fef2fd3","stubGroupName":"CAMS私桩群（高新区）","stubId":null,"frameWork":null,"modelNo":null,"updateType":null},{"serial":7,"cityId":"320412","date":"202110","operationMode":"1","operationProperty":"3","type":2,"createTime":null,"totalErrorStub":1,"totalOfflineStub":0,"totalOfflineDuration":0,"totalErrorDuration":1641600,"totalOperationDuration":1641600,"stubCnt":1,"totalAvailableDuration":1641600,"totalMaintDuration":0,"availableCnt":1,"errorRate":100.00,"offlineRate":0.00,"intactRate":0.00,"availableRate":100.00,"cityName":"常州市","provinceName":"江苏省","areaName":"武进区","stubGroupId":"fd802c90-2561-4dd8-bbda-d7e9bd093644","stubGroupName":"阿黄黄专属电站2","stubId":null,"frameWork":null,"modelNo":null,"updateType":null},{"serial":8,"cityId":"320412","date":"202110","operationMode":"1","operationProperty":"3","type":1,"createTime":null,"totalErrorStub":1,"totalOfflineStub":0,"totalOfflineDuration":0,"totalErrorDuration":1641600,"totalOperationDuration":1641600,"stubCnt":1,"totalAvailableDuration":1641600,"totalMaintDuration":0,"availableCnt":1,"errorRate":100.00,"offlineRate":0.00,"intactRate":0.00,"availableRate":100.00,"cityName":"常州市","provinceName":"江苏省","areaName":"武进区","stubGroupId":"ed5d09d8-8851-4e62-8c4e-5c8093abe23b","stubGroupName":"天润国际测试站","stubId":null,"frameWork":null,"modelNo":null,"updateType":null},{"serial":9,"cityId":"320412","date":"202110","operationMode":"0","operationProperty":"3","type":1,"createTime":null,"totalErrorStub":1,"totalOfflineStub":0,"totalOfflineDuration":0,"totalErrorDuration":1641600,"totalOperationDuration":1641600,"stubCnt":1,"totalAvailableDuration":1641600,"totalMaintDuration":0,"availableCnt":1,"errorRate":100.00,"offlineRate":0.00,"intactRate":0.00,"availableRate":100.00,"cityName":"常州市","provinceName":"江苏省","areaName":"武进区","stubGroupId":"d73b954d-3239-4a5f-b79b-6b4057d89079","stubGroupName":"CAMS私桩群（南夏墅）","stubId":null,"frameWork":null,"modelNo":null,"updateType":null},{"serial":10,"cityId":"320412","date":"202110","operationMode":"1","operationProperty":"3","type":2,"createTime":null,"totalErrorStub":2,"totalOfflineStub":1,"totalOfflineDuration":1641600,"totalErrorDuration":3283200,"totalOperationDuration":6566400,"stubCnt":4,"totalAvailableDuration":6566400,"totalMaintDuration":0,"availableCnt":4,"errorRate":50.00,"offlineRate":25.00,"intactRate":25.00,"availableRate":100.00,"cityName":"常州市","provinceName":"江苏省","areaName":"武进区","stubGroupId":"9d44d3c6-b1ee-435f-b9b6-527b594beacc","stubGroupName":"南夏墅0310一号站","stubId":null,"frameWork":null,"modelNo":null,"updateType":null}];
      window.sessionStorage.setItem("top10Station", JSON.stringify(res.data));
      this.setState(
        {
          tableDate: res.data,
        },
        () => {
          this.setState({
            tableConfig: this.initTable(),
          });
        },
      );
    });
  }

  /**
   * 父组件传递参数改变后执行
   */
  componentWillReceiveProps(nextProps) {
    /**
     * 判断是否改变排序方式
     */
    if (
      this.state.sortFunc.sortKey === nextProps.sort.sortKey
      && this.state.sortFunc.sortFun === nextProps.sort.sortFun
    ) {
      /**
       * 排序方式未改变
       */
      if (
        this.props.param.cityId === nextProps.param.cityId
        && this.props.param.operationProperty === nextProps.param.operationProperty
        && this.props.param.operationMode === nextProps.param.operationMode
        && this.props.param.type === nextProps.param.type
        && this.props.param.date === nextProps.param.date
      ) {
        /**
         * 如果查询参数没有改变，直接返回，不继续执行
         */

      } else {
        /**
         * 如果查询参数改变，设置参数，调用接口获取数据，重新渲染表格
         */
        console.log("查询表格，并重新加载表格");
        this.setState(
          {
            cityId: nextProps.param.cityId,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
            type: nextProps.param.type,
            time: nextProps.param.date,
          },
          () => {
            this.queryEndCodeChargInfo();
          },
        );
      }
    } else {
      /**
       * 排序方式改变，修改参数，调用接口，重新渲染表格
       */
      this.setState(
        {
          sortFunc: nextProps.sort,
          cityId: nextProps.param.cityId,
          operationProperty: nextProps.param.operationProperty,
          operationMode: nextProps.param.operationMode,
          type: nextProps.param.type,
          time: nextProps.param.date,
        },
        () => {
          this.queryEndCodeChargInfo();
          console.log("查询表格，并重新加载表格");
        },
      );
    }
  }

  render() {
    const val = (
      <div className='analysis-content-3'>
        <ScGridTable config={this.state.tableConfig} />
      </div>
    );

    return val;
  }
}

export default StationIntactTop10;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stationIntactTop10.js